import React from 'react';

export interface FileNameListItem {
  id: string;
  primary: string;
  secondary?: string;
  icon: React.ReactNode;
}

interface FileNameListProps {
  items: FileNameListItem[];
}

/**
 * The scroll box the three file lists share. The icon sits in a fixed-width
 * column so a two-line entry keeps its text aligned with a one-line entry —
 * what MUI's ListItemIcon gutter was doing.
 */
const FileNameList: React.FC<FileNameListProps> = ({ items }) => (
  <div className="max-h-[200px] overflow-auto rounded-md border p-2">
    <ul>
      {items.map((item) => (
        <li key={item.id} className="flex items-center gap-3 px-2 py-1">
          <span className="flex w-6 shrink-0 items-center justify-center">{item.icon}</span>
          <div className="min-w-0">
            <p title={item.primary} className="revy-cjk truncate text-sm leading-[1.5]">
              {item.primary}
            </p>
            {/* The secondary slot carries the upload error message; it wraps
                rather than clipping so the whole diagnostic stays readable. */}
            {item.secondary && (
              <p className="revy-cjk revy-figure text-xs leading-[1.5] text-muted-foreground">
                {item.secondary}
              </p>
            )}
          </div>
        </li>
      ))}
    </ul>
  </div>
);

export default FileNameList;
